import classNames from 'classnames';
import { ReactNode } from 'react';
import { useBreakpoint } from '~/hooks/useBreakpoint';

type ViewCardProps = {
  label: string;
  children: ReactNode;
};

export function ViewCard({ label, children }: ViewCardProps) {
  const { isMobile } = useBreakpoint();

  return (
    <div
      className={classNames(
        'flex flex-col gap-5 rounded-xl border border-outline-variant bg-surface-container-background shadow-md',
        isMobile ? 'px-3 pt-4' : 'px-5 pt-5'
      )}
    >
      <h6 className='text-lg font-medium leading-5'>{label}</h6>
      <div className={classNames(isMobile ? 'pb-4' : 'pb-5')}>{children}</div>
    </div>
  );
}
